import { ROLES_LIST } from '@/js/constants';
export default [{
  icon: 'mdi-home-outline',
  name: 'Home',
  key: 'menu.customer.home',
  link: '/customer_insights/home',
  href: {
    name: 'InsightsHome'
  },
  roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.INSIGHTS_SOMOS1_DATA_ENTRY_USER, ROLES_LIST.INSIGHTS_SOMOS1_CORP_VIEWER, ROLES_LIST.INSIGHTS_USER_SOMOS1, ROLES_LIST.INSIGHTS_BUSINESS_USER]
}, {
  name: 'Somos1List',
  key: 'menu.customer.somos1',
  subname: '',
  icon: 'mdi-chart-box-plus-outline',
  roles: [ROLES_LIST.INSIGHTS_USER_SOMOS1, ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_SOMOS1_DATA_ENTRY_USER, ROLES_LIST.INSIGHTS_SOMOS1_CORP_VIEWER, ROLES_LIST.INSIGHTS_BUSINESS_USER, ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [{
    name: 'Somos1Home',
    key: 'menu.customer.somos1_home',
    href: {
      name: 'Somos1Home'
    },
    link: '/customer_insights/somos1_home',
    roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.INSIGHTS_SOMOS1_DATA_ENTRY_USER, ROLES_LIST.INSIGHTS_SOMOS1_CORP_VIEWER, ROLES_LIST.INSIGHTS_USER_SOMOS1, ROLES_LIST.INSIGHTS_BUSINESS_USER]
  }, {
    name: 'Somos1DataEntry',
    key: 'menu.customer.somos1_data_entry',
    href: {
      name: 'Somos1DataEntry'
    },
    link: '/customer_insights/data_entry',
    roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_SOMOS1_DATA_ENTRY_USER, ROLES_LIST.INSIGHTS_SOMOS1_CORP_VIEWER, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Somos1Dashboard',
    key: 'menu.customer.somos1_reports',
    href: {
      name: 'somos1_list'
    },
    link: '/customer_insights/somos1',
    roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_USER_SOMOS1, ROLES_LIST.INSIGHTS_SOMOS1_CORP_VIEWER, ROLES_LIST.INSIGHTS_BUSINESS_USER, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'TrackingDataEntry',
    key: 'menu.customer.tracking_dataentry',
    href: {
      name: 'tracking_dataentry'
    },
    link: '/customer_insights/tracking_dataentry',
    roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_SOMOS1_CORP_VIEWER]
  }]
}, {
  name: 'Somos1V2List',
  key: 'menu.customer.somos1_v2',
  subname: '',
  icon: 'mdi-chart-box-plus-outline',
  roles: [ROLES_LIST.INSIGHTS_USER_SOMOS1, ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_SOMOS1_DATA_ENTRY_USER, ROLES_LIST.INSIGHTS_SOMOS1_CORP_VIEWER, ROLES_LIST.INSIGHTS_BUSINESS_USER, ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [{
    name: 'Somos1V2RegionalIndicators1',
    key: 'menu.customer.somos1_v2_regional_1',
    href: {
      name: 'somos1_v2_regional_1'
    },
    link: '/customer_insights/somos1_v2/regional_indicators_1',
    roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_USER_SOMOS1, ROLES_LIST.INSIGHTS_SOMOS1_CORP_VIEWER, ROLES_LIST.INSIGHTS_BUSINESS_USER, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Somos1V2RegionalIndicators2',
    key: 'menu.customer.somos1_v2_regional_2',
    href: {
      name: 'somos1_v2_regional_2'
    },
    link: '/customer_insights/somos1_v2/regional_indicators_2',
    roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_USER_SOMOS1, ROLES_LIST.INSIGHTS_SOMOS1_CORP_VIEWER, ROLES_LIST.INSIGHTS_BUSINESS_USER, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Somos1V2Configuration',
    key: 'menu.customer.somos1_v2_configuration',
    href: {
      name: 'somos1_v2_configuration'
    },
    link: '/customer_insights/somos1_v2/configuration',
    roles: [ROLES_LIST.INSIGHTS_ADMIN]
  }]
}, {
  icon: 'mdi-office-building-outline',
  name: 'Companies',
  key: 'menu.customer.companies',
  link: '/customer_insights/companies',
  href: {
    name: 'CompaniesReportsHome'
  },
  roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_BUSINESS_USER, ROLES_LIST.ORG_DATA_STEWARD]
}, {
  name: 'Huascaran',
  key: 'menu.customer.huascaran',
  subname: '',
  icon: 'mdi-file-document-outline',
  roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_BUSINESS_USER, ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [{
    name: 'Reports Huascaram',
    key: 'menu.customer.huascaram_reports',
    href: {
      name: 'HuascaranReportsList'
    },
    link: '/customer_insights/huascaran/reports',
    roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_BUSINESS_USER, ROLES_LIST.ORG_DATA_STEWARD]
  }]
},
// {
//   name: 'Companies',
//   key: 'menu.customer.companies',
//   subname: '',
//   link: '/customer_insights/companies',
//   icon: 'mdi-office-building-outline',
//   roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_BUSINESS_USER],
// subItems: [
//   {
//     name: 'companies_list',
//     key: 'menu.customer.companies_reports',
//     href: { name: 'companies_list' },
//     link: '/customer_insights/companies',
//     roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_BUSINESS_USER]
//   }
// ]
// },
{
  name: 'Maintenance',
  key: 'menu.customer.maintenance',
  subname: '',
  icon: 'icon-maintenance',
  roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_SERVICE_MANAGER],
  subItems: [{
    name: 'Somos1Maintenance',
    key: 'menu.customer.somos1_reports',
    href: {
      name: 'CustomerInsightsMaintenance'
    },
    link: '/customer_insights/maintenance/somos1',
    roles: [ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.INSIGHTS_SERVICE_MANAGER]
  }]
}];